import Head from "next/head"
import { useState } from "react"
import { Skeleton, Spin } from "antd"
import CheckoutLayout from "@/components/CheckoutLayout"
import Steps from "@/components/checkout/steps"
import ProgressBar from "@/components/ProgressBar"
import CartBulkActions from "@/components/view-cart/CartBulkActions"
import CartHeader from "@/components/view-cart/CartHeader"
import CartInfoLinks from "@/components/view-cart/CartInfoLinks"
import CartTable from "@/components/view-cart/CartTable"
import CheckoutActions from "@/components/view-cart/CheckoutActions"
import DeleteConfirmModal from "@/components/view-cart/DeleteConfirmModal"
import DiscountPanel from "@/components/view-cart/DiscountPanel"
import EmptyCart from "@/components/view-cart/EmptyCart"
import OrderSummary from "@/components/view-cart/OrderSummary"
import PaymentTrustFooter from "@/components/view-cart/PaymentTrustFooter"
import RecommendationSection from "@/components/view-cart/RecommendationSection"
import ShippingEstimator from "@/components/view-cart/ShippingEstimator"
import SoldOutCartTable from "@/components/view-cart/SoldOutCartTable"
import { useViewCartPage } from "@/components/view-cart/hooks/useViewCartPage"
import AddOnInfoModal from "@/components/productDetail/AddOnInfoModal"
import styles from "@/styles/view-cart.module.scss"

export default function Viewcar() {
  const [showAddOnInfoModal, setShowAddOnInfoModal] = useState(false)
  const {
    applyBtnLoading,
    applyDiscount,
    betchAddWishlist,
    betchAddWishunAvailablelist,
    betchDelete,
    betchDeleteAvailablelist,
    checkoutEvent,
    coupon,
    couponInputChange,
    couponPackage,
    credits,
    creditsInput,
    deleteArray,
    deleteCart,
    deleteItem,
    deleteLoading,
    discountInfo,
    displayList,
    effectiveList,
    expressChange,
    handleOpenPaypal,
    helpText,
    inputFocus,
    invalidityList,
    isFirst,
    isLogin,
    isModalOpen,
    isUleeId,
    loading,
    loadingRows,
    packagesList,
    paymentInfo,
    paymentLoading,
    points,
    pointsInput,
    postCode,
    postCodeChange,
    qtyChange,
    rowSelection,
    slectCoupons,
    selectedRowKeys,
    selectNum,
    setCreditsInput,
    setInputFocus,
    setIsModalOpen,
    setPointsInput,
    setShowCoupon,
    setSuburb,
    showCoupon,
    showSaveCart,
    suburb,
    suburbList,
    successAddCart,
    updataCartList,
    wishlistItem,
  } = useViewCartPage()

  return (
    <>
      <Head>
        <title>Online Shopping Australia – Beauty &amp; Health, Computers, Toys, - Deals &amp; Discounts | CrazySales</title>

        <meta name="keywords" content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales" />
        <meta name="description" content="CrazySales.com.au - Australia&#039;s #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we&#039;ve got it all, with free shipping on selected items!" />
        <meta name="geo.placename" content="Australia" />
        <meta name="geo.position" content="-25.274398;133.775136" />
        <meta name="ICBM" content="-25.274398, 133.775136" />
        <meta name="viewport" content="width=1100, initial-scale=0.75" />
      </Head>
      <CheckoutLayout>
        <Spin spinning={paymentLoading} wrapperClassName={'ant-spin-wrapper'}>
          <div className={styles['main']}>
            <div className={styles['viewcar']}>
              <Steps value={0} />

              <CartInfoLinks />
              <ProgressBar isAnimating={loading} />
              {
                isFirst ? <Skeleton loading active paragraph={{ rows: 16 }} />
                  :
                  (effectiveList.length > 0 || invalidityList.length > 0)
                    ?
                    <div className={styles["shopping-cart"]}>
                      <CartHeader onCheckout={() => { checkoutEvent(() => { window.location.href = '/checkout' }) }} />

                      <CartBulkActions
                        selectedCount={selectNum}
                        onDelete={() => { betchDelete(selectedRowKeys) }}
                        onMoveToWishlist={betchAddWishlist}
                      />

                      <CartTable
                        dataSource={displayList}
                        loadingRows={loadingRows}
                        rowSelection={rowSelection}
                        onAddonInfoClick={() => setShowAddOnInfoModal(true)}
                        onDeleteItem={deleteItem}
                        onExpressChange={expressChange}
                        onQtyChange={qtyChange}
                        onWishlistItem={wishlistItem}
                      />

                      <SoldOutCartTable
                        dataSource={invalidityList}
                        loadingRows={loadingRows}
                        onDeleteAvailableList={betchDeleteAvailablelist}
                        onDeleteItem={deleteItem}
                        onExpressChange={expressChange}
                        onMoveAvailableListToWishlist={betchAddWishunAvailablelist}
                        onQtyChange={qtyChange}
                        onWishlistItem={wishlistItem}
                      />

                      <div className={styles["payment-box"]}>
                        <div>
                          <ShippingEstimator
                            postCode={postCode}
                            suburb={suburb}
                            suburbList={suburbList}
                            helpText={helpText}
                            onPostCodeChange={postCodeChange}
                            onSuburbSelect={(value: any) => { setSuburb(value) }}
                          />
                          {
                            !(isUleeId && !isLogin)
                            &&
                            <DiscountPanel
                              applyBtnLoading={applyBtnLoading}
                              coupon={coupon}
                              couponPackage={couponPackage}
                              credits={credits}
                              creditsInput={creditsInput}
                              inputFocus={inputFocus}
                              isLogin={isLogin}
                              packagesList={packagesList}
                              points={points}
                              pointsInput={pointsInput}
                              showCoupon={showCoupon}
                              onApplyDiscount={applyDiscount}
                              onCouponChange={couponInputChange}
                              onCouponFocusChange={setInputFocus}
                              onCouponPackageChange={slectCoupons}
                              onCreditsInputChange={setCreditsInput}
                              onPointsInputChange={setPointsInput}
                              onToggleCoupon={() => { setShowCoupon(!showCoupon) }}
                            />
                          }
                        </div>
                        <OrderSummary paymentInfo={paymentInfo} discountInfo={discountInfo} />
                      </div>

                      <CheckoutActions
                        isUleeId={isUleeId}
                        paymentInfo={paymentInfo}
                        selectedRowKeys={selectedRowKeys}
                        showSaveCart={showSaveCart}
                        onCheckout={checkoutEvent}
                        onOpenPaypal={handleOpenPaypal}
                      />

                      <PaymentTrustFooter
                        onAddOnSuccess={updataCartList}
                        totalAmount={paymentInfo?.total}
                      />
                    </div>
                    :
                    <EmptyCart />
              }

              <RecommendationSection type="wishilist" successAddCart={successAddCart} isLogin={isLogin} />
              <RecommendationSection type="related" list={effectiveList} successAddCart={successAddCart} />
            </div>

            <DeleteConfirmModal
              open={isModalOpen}
              loading={deleteLoading}
              deleteArray={deleteArray}
              onOk={deleteCart}
              onCancel={() => { setIsModalOpen(false) }}
            />
            <AddOnInfoModal
              open={showAddOnInfoModal}
              onClose={() => setShowAddOnInfoModal(false)}
            />
          </div>
        </Spin>
      </CheckoutLayout>
    </>
  )
}
